import { render, staticRenderFns } from "./setting-base.vue?vue&type=template&id=3157fe53&scoped=true&"
import script from "./setting-base.vue?vue&type=script&lang=js&"
export * from "./setting-base.vue?vue&type=script&lang=js&"
import style0 from "./setting-base.vue?vue&type=style&index=0&id=3157fe53&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3157fe53",
  null
  
)

export default component.exports